<table mat-table [dataSource]="billingData" matSort>
  @for (column of columns; track column; let i = $index) {
    <ng-container matColumnDef="{{column}}">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{headings[i]}} </th>
      <td mat-cell *matCellDef="let element">
        @if (column === 'runId') {
          {{element[column]}}
          }@else if (column === 'organisations' || column === 'nodes' || column === 'projects' || column === 'users') {
          {{element[column].amount | currency: currencyCode: 'symbol-narrow': '1.0-0'}}
          }@else {
          {{(element.states[column]?element.states[column].amount:0) | currency: currencyCode: 'symbol-narrow': '1.0-0'}}
        }
      </td>
    </ng-container>
  }

  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let element; columns: columns;" (click)="selectRow(element)" [ngClass]="selectedRunId===element.runId?'selected-row':''"></tr>
</table>
